// import './Thumbnail.css'
import './Thumbnail.less';

export function Thumbnail({ src, isActive, onClick, onMouseEnter }) {
  return (
    <div
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      className={isActive ? 'thumbnail active' : 'thumbnail'}
    >
      <img src={src} alt="" />
    </div>
  );
}